/**
 * Wellness diary — shared render helpers.
 *
 * The field catalog itself lives on the backend (single source of truth,
 * fetched via `GET /api/wellness/catalog`); this module only holds presentation
 * helpers so the coach and athlete surfaces render values the same way.
 * Spec: docs/wellness/00-analisi-e-piano.md
 */

export const WELLNESS_SCALE_OPTIONS = [1, 2, 3, 4, 5];

/* Colore della linea per direzione del trend. Due set: su fondo chiaro
   l'acid (#CCFF00) ha contrasto 1,2:1 sul bianco, cioe' la linea sparisce.
   Il set "dark" e' esattamente quello storico. */
const DIRECTION_COLORS = {
	dark: {
		higher: "#CCFF00", // acid — more is better
		lower: "#FF9500", // orange — less is better
		neutral: "#007AFF", // volt — just a trend
	},
	light: {
		higher: "#7A9900",
		lower: "#C2570A",
		neutral: "#0062CC",
	},
};

export function wellnessFieldColor(field, theme = "dark") {
	const set = DIRECTION_COLORS[theme] || DIRECTION_COLORS.dark;
	return set[field?.direction] || set.neutral;
}

export function formatWellnessValue(field, value) {
	if (value === null || value === undefined || value === "") return "-";
	if (field?.type === "scale_1_5") return `${value}/5`;
	if (field?.type === "number") {
		return field.unit ? `${value} ${field.unit}` : String(value);
	}
	return String(value);
}

export function wellnessUnitLabel(field) {
	return field?.unit || "";
}

// Only numeric/scale fields are plottable; text (notes) is not.
export function isChartableField(field) {
	return field?.type === "scale_1_5" || field?.type === "number";
}

// Build a Recharts-ready series for one field from the raw entries list.
export function buildWellnessSeries(entries, fieldKey) {
	return (entries || [])
		.filter(
			(entry) =>
				entry?.values?.[fieldKey] !== null &&
				entry?.values?.[fieldKey] !== undefined &&
				entry?.values?.[fieldKey] !== "",
		)
		.map((entry) => ({
			date: entry.date ? String(entry.date).slice(5) : "",
			value: Number(entry.values[fieldKey]),
		}));
}
